// Central API base for KGOnline / MFSetu frontends.
// Web/local development uses /api (CRA dev proxy forwards it to the VPS).
// Mobile builds can set REACT_APP_API_BASE=https://kgonline.in/api.
export const API_BASE = process.env.REACT_APP_API_BASE || "/api";
